/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessUpdateMemberRoles } from "../funcs/accessUpdateMemberRoles.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AccessMember } from "../models/components/accessmember.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateMemberRolesRequest,
  UpdateMemberRolesSecurity,
} from "../models/operations/updatememberroles.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateMemberRolesMutationVariables = {
  request: UpdateMemberRolesRequest;
  security?: UpdateMemberRolesSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateMemberRolesMutationData = AccessMember;

export type UpdateMemberRolesMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateMemberRoles access
 *
 * @remarks
 * Update a team member's role assignments.
 */
export function useUpdateMemberRolesMutation(
  options?: MutationHookOptions<
    UpdateMemberRolesMutationData,
    UpdateMemberRolesMutationError,
    UpdateMemberRolesMutationVariables
  >,
): UseMutationResult<
  UpdateMemberRolesMutationData,
  UpdateMemberRolesMutationError,
  UpdateMemberRolesMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateMemberRolesMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateMemberRoles(): MutationKey {
  return ["@gram/client", "access", "updateMemberRoles"];
}

export function buildUpdateMemberRolesMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateMemberRolesMutationVariables,
  ) => Promise<UpdateMemberRolesMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateMemberRoles(),
    mutationFn: function updateMemberRolesMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateMemberRolesMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(accessUpdateMemberRoles(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
